// extracted by css-extract-rspack-plugin
export default {"tooltipContent":"RQud6FEU6PQxUEYu"};